/* RΞBΛY — theme behaviour.
   Plain ES2019, no build step: everything here is readable in the theme editor
   and edits go live with a theme push. */
(function () {
  'use strict';

  var CFG = window.REBAY || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  function formatMoney(cents) {
    // Mirrors Shopify's amount / amount_with_comma_separator formats well
    // enough for cart maths; server-rendered prices remain authoritative.
    var fmt = CFG.moneyFormat || '{{amount}}';
    var comma = fmt.indexOf('comma_separator') > -1;
    var noDecimals = fmt.indexOf('no_decimals') > -1;
    var n = cents / 100;
    var s = noDecimals
      ? Math.round(n).toFixed(0)
      : n.toFixed(2);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    s = parts.join(comma ? ',' : '.');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, s);
  }

  /* ── intro curtain ─────────────────────────────────────────────────────── */

  function intro() {
    var el = $('[data-intro]');
    if (!el) return;
    try {
      if (sessionStorage.getItem('rebay:seen')) { el.remove(); return; }
      sessionStorage.setItem('rebay:seen', '1');
    } catch (e) {}
    if (reduceMotion) { el.remove(); return; }
    setTimeout(function () {
      el.classList.add('is-out');
      setTimeout(function () { el.remove(); }, 1100);
    }, 1700);
  }

  /* ── header state ──────────────────────────────────────────────────────── */

  function header() {
    var el = $('[data-header]');
    if (!el) return;
    function update() {
      el.classList.toggle('is-stuck', window.scrollY > 40);
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ── reveal + parallax ─────────────────────────────────────────────────── */

  function reveal() {
    var items = $$('.reveal');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    items.forEach(function (i) { io.observe(i); });
  }

  function parallax() {
    var items = $$('[data-parallax]');
    if (!items.length || reduceMotion) return;
    var ticking = false;
    function frame() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var depth = parseFloat(el.dataset.parallax) || 0.1;
        var mid = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (-mid * depth).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    function request() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(frame);
    }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    frame();
  }

  /* ── panels (menu, cart, search) ───────────────────────────────────────── */

  var openPanel = null;

  function closePanel() {
    if (!openPanel) return;
    openPanel.classList.remove('is-open');
    var scrim = $('[data-scrim]');
    if (scrim) scrim.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    if (openPanel.__opener) openPanel.__opener.focus();
    openPanel = null;
  }

  function showPanel(panel, opener) {
    if (!panel) return;
    if (openPanel && openPanel !== panel) closePanel();
    panel.__opener = opener || null;
    panel.classList.add('is-open');
    var scrim = $('[data-scrim]');
    if (scrim) scrim.classList.add('is-open');
    document.body.classList.add('is-locked');
    openPanel = panel;
    var focusable = panel.querySelector('input, button, a[href]');
    if (focusable) setTimeout(function () { focusable.focus(); }, 120);
  }

  function panels() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-panel-open]');
      if (trigger) {
        e.preventDefault();
        showPanel($('[data-panel="' + trigger.dataset.panelOpen + '"]'), trigger);
        return;
      }
      if (e.target.closest('[data-panel-close]') || e.target.closest('[data-scrim]')) {
        e.preventDefault();
        closePanel();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });
  }

  /* ── cart ──────────────────────────────────────────────────────────────── */

  function repaintCart(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var target = document.getElementById('shopify-section-' + id);
      if (target && sections[id]) {
        var doc = new DOMParser().parseFromString(sections[id], 'text/html');
        var fresh = doc.getElementById('shopify-section-' + id);
        if (fresh) target.innerHTML = fresh.innerHTML;
      }
    });
    var count = $('[data-cart-count]');
    var fresh = $('[data-cart-count-source]');
    if (count && fresh) count.textContent = fresh.textContent;
  }

  function cartSections() {
    return ['cart-drawer'].filter(function (id) {
      return document.getElementById('shopify-section-' + id);
    });
  }

  function addToCart(form, button) {
    var body = new FormData(form);
    var wanted = cartSections();
    if (wanted.length) body.append('sections', wanted.join(','));

    var original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = CFG.strings.adding || 'Adding';
    }

    return fetch(CFG.cartAddUrl + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (button) button.textContent = res.json.description || res.json.message || 'Unavailable';
          setTimeout(function () {
            if (button) { button.textContent = original; button.disabled = false; }
          }, 2600);
          return;
        }
        repaintCart(res.json.sections);
        if (button) { button.textContent = CFG.strings.added || 'Added'; }
        showPanel($('[data-panel="cart"]'));
        setTimeout(function () {
          if (button) { button.textContent = original; button.disabled = false; }
        }, 1800);
      })
      .catch(function () { form.submit(); });
  }

  function changeLine(key, quantity) {
    var wanted = cartSections();
    return fetch(CFG.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: wanted.join(',') })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        repaintCart(json.sections);
        // The cart page is server-rendered, so reload it rather than trying to
        // patch a layout the drawer sections don't cover.
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }

  function cart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-add-to-cart]');
      if (!form) return;
      e.preventDefault();
      addToCart(form, form.querySelector('[data-add-button]'));
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-line-change]');
      if (!btn) return;
      e.preventDefault();
      changeLine(btn.dataset.lineKey, parseInt(btn.dataset.lineQty, 10));
    });
  }

  /* ── product form ──────────────────────────────────────────────────────── */

  function productForm(root) {
    var dataEl = $('[data-variants]', root);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = $('[data-variant-id]', root);
    var priceEl = $('[data-price]', root);
    var button = $('[data-add-button]', root);
    var mainImg = $('[data-main-image]', root);
    var chosen = {};

    $$('[data-option-index]', root).forEach(function (el) {
      if (el.getAttribute('aria-checked') === 'true') {
        chosen[el.dataset.optionIndex] = el.dataset.optionValue;
      }
    });

    function match(partial) {
      return variants.find(function (v) {
        return Object.keys(partial).every(function (i) {
          return v.options[i] === partial[i];
        });
      });
    }

    function paint() {
      var variant = match(chosen);

      $$('[data-option-index]', root).forEach(function (el) {
        var i = el.dataset.optionIndex;
        var value = el.dataset.optionValue;
        el.setAttribute('aria-checked', chosen[i] === value ? 'true' : 'false');
        // Grey out combinations that cannot be bought with the current picks.
        var probe = Object.assign({}, chosen);
        probe[i] = value;
        var candidate = match(probe);
        el.classList.toggle('is-unavailable', !candidate || !candidate.available);
      });

      if (priceEl && variant) priceEl.innerHTML = variant.price_html;
      if (idInput) idInput.value = variant ? variant.id : '';

      if (button) {
        var buyable = !!(variant && variant.available);
        button.disabled = !buyable;
        button.textContent = buyable
          ? (button.dataset.labelAdd || CFG.strings.addToBag)
          : (CFG.strings.soldOut || 'Sold out');
      }

      if (mainImg && variant && variant.image) {
        mainImg.src = variant.image;
        $$('[data-thumb]', root).forEach(function (t) {
          t.setAttribute('aria-current', t.dataset.thumb === variant.image ? 'true' : 'false');
        });
      }
    }

    root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-option-index]');
      if (el) {
        e.preventDefault();
        chosen[el.dataset.optionIndex] = el.dataset.optionValue;
        paint();
        return;
      }
      var thumb = e.target.closest('[data-thumb]');
      if (thumb && mainImg) {
        e.preventDefault();
        mainImg.src = thumb.dataset.thumb;
        $$('[data-thumb]', root).forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      }
    });

    paint();
  }

  /* ── countdown ─────────────────────────────────────────────────────────── */

  function countdown() {
    $$('[data-countdown]').forEach(function (root) {
      var target = Date.parse(root.dataset.countdown);
      if (isNaN(target)) return;
      var out = {
        d: $('[data-cd="d"]', root), h: $('[data-cd="h"]', root),
        m: $('[data-cd="m"]', root), s: $('[data-cd="s"]', root)
      };
      function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
      function tick() {
        var left = Math.max(0, target - Date.now());
        var secs = Math.floor(left / 1000);
        if (out.d) out.d.textContent = pad(Math.floor(secs / 86400));
        if (out.h) out.h.textContent = pad(Math.floor(secs / 3600) % 24);
        if (out.m) out.m.textContent = pad(Math.floor(secs / 60) % 60);
        if (out.s) out.s.textContent = pad(secs % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ── product recommendations ───────────────────────────────────────────── */

  function related() {
    var el = $('[data-related][data-url]');
    if (!el) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-related]');
        if (!fresh || !fresh.innerHTML.trim()) return;
        el.innerHTML = fresh.innerHTML;
        el.classList.add('is-in');
      })
      .catch(function () {});
  }

  /* ── predictive search ─────────────────────────────────────────────────── */

  function search() {
    var input = $('[data-search-input]');
    var results = $('[data-search-results]');
    if (!input || !results || !CFG.predictiveSearchUrl) return;
    var timer;

    on(input, 'input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var url = CFG.predictiveSearchUrl
          + '?q=' + encodeURIComponent(q)
          + '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var list = doc.querySelector('[data-search-results]');
            results.innerHTML = list ? list.innerHTML : '';
          })
          .catch(function () { results.innerHTML = ''; });
      }, 220);
    });
  }

  /* ── boot ──────────────────────────────────────────────────────────────── */

  function boot() {
    intro();
    header();
    reveal();
    parallax();
    panels();
    cart();
    countdown();
    search();
    related();
    $$('[data-product-form]').forEach(productForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (e) {
    reveal();
    parallax();
    countdown();
    $$('[data-product-form]', e.target).forEach(productForm);
  });
})();
